
<template>
  <div class="section_inner">
    <v-container pa-0 px-2>
      <v-layout fill-height class="tile-layout" justify-space-between>
        <v-flex class="article-layout hidden-sm-and-down first-item display-23" sm3>
          <div class="useful-tools">{{ title }}</div>
        </v-flex>
        <v-flex
          v-for="(item, index) in tools"
          :key="index"
          xs4
          sm4
          px-3
          py-4
          class="tile-item d-flex align-center"
        >
          <ArticleTile :item="item" :icon="icons[index]" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ArticleTile from '@/components/Articles/ArticleTile'

export default {
  components: {
    ArticleTile
  },
  data() {
    return {
      showSmart: true,
      scrollPosition: null,
      dialog: false,
      iconAgent: 'icon-agent',
      icons: ['icon-dollar-symbol', 'icon-shopping-list', 'icon-resume']
    }
  },
  props: {
    title: {
      type: String,
      required: false
    },
    tools: {
      type: Array,
      required: false
    }
  }
}
</script>

<style  scoped lang="scss">
.article-layout.first-item {
  background: #ff7100;
  color: #fff;
  border-radius: 30px;
  max-width: 141px;
  height: 135px;
  text-align: right;
  border: 4px solid white;
  position: relative;
}

.useful-tools {
  position: absolute;
  top: 30%;
  display: block;
  right: 17%;
}

.tile-layout {
  height: 134px;
}

.tile-item {
  border-radius: 30px;
  max-width: 362px;
  height: 135px;
  padding: inherit;
  background: #f6f7f9;
  position: relative;
  color: #231f20;
  border: 4px solid white;
}

.tile-item:hover {
  border: 1px solid $primary;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  /* .fade-leave-active below version 2.1.8 */
  opacity: 0;
}

@media screen and (max-width: 1280px) {
}

@media screen and (max-width: 768px) {
}

@media only screen and (max-width: 960px) {
  .tile-item {
    height: 145px;
  }
}

@media screen and (max-width: 480px) {
}

@media screen and (max-width: 400px) {
}
</style>
